import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["classes", "type", "children", "textProps", "color", "backgroundColor"];

var _colorsMap;

import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../constants";
import { cssUtils } from "../internal/CssUtils";
import { TextBase } from "../internal/TextBase";
import { types } from './constants';
import styles from './TableStatus.css';
var cx = classNames.bind(styles);
var colorsMap = (_colorsMap = {}, _defineProperty(_colorsMap, types.ghost, 'N100'), _defineProperty(_colorsMap, types.warning, 'O600'), _colorsMap);
export var TableStatus = /*#__PURE__*/forwardRef(function TableStatus(_ref, ref) {
  var _cx;

  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      type = _ref.type,
      children = _ref.children,
      _ref$textProps = _ref.textProps,
      textProps = _ref$textProps === void 0 ? defaultPropObject : _ref$textProps,
      color = _ref.color,
      backgroundColor = _ref.backgroundColor,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: ref,
    className: cx('root', (_cx = {}, _defineProperty(_cx, "type_".concat(type), type && !backgroundColor), _defineProperty(_cx, "".concat(cssUtils("backgroundColor_".concat(backgroundColor))), backgroundColor), _cx), classes.root)
  }), /*#__PURE__*/React.createElement(TextBase, _extends({}, textProps, {
    as: "div",
    weight: "semibold",
    color: type ? colorsMap[type] : color
  }), /*#__PURE__*/React.createElement("div", {
    className: cx('text')
  }, children)));
});